// src/services/desktop.js
//
// Downloading an installer, and guessing which one the visitor wants.

import api from './api';
import { API_BASE_URL } from '../config/api';

// A tool's builds arrive as a plain object keyed by platform ("mac", "windows").
export const buildsOf = (tool) => tool?.desktopBuilds || {};

export const hasDesktopBuild = (tool) => Object.keys(buildsOf(tool)).length > 0;

// Which platform this browser is on, as a key from the platform list, or null
// when it's something we don't ship for. Only ever used to *reorder* the
// choices — every build stays reachable, because people download installers
// for the laptop they're about to set up, not the one they're holding.
export const detectPlatform = (platforms = []) => {
  const ua = `${navigator.userAgentData?.platform || ''} ${navigator.platform || ''} ${navigator.userAgent || ''}`
    .toLowerCase();

  // iPads and iPhones report a Mac-ish UA but can't run a .dmg.
  if (/iphone|ipad|ipod|android/.test(ua)) return null;

  return platforms.find((p) => ua.includes(p.match))?.key || null;
};

export const formatSize = (bytes) => {
  if (!bytes && bytes !== 0) return '';
  const mb = bytes / (1024 * 1024);
  return mb >= 1024 ? `${(mb / 1024).toFixed(1)} GB` : `${Math.round(mb)} MB`;
};

// Downloads go through a short-lived ticket rather than the JWT header: this
// hands the file to the browser's own download manager, so a 200 MB installer
// streams to disk with a progress bar instead of sitting in a blob in memory.
export const downloadDesktopBuild = async (toolId, platform) => {
  const { data } = await api.post(`/tools/${toolId}/desktop/${platform}/ticket`);
  window.location.href =
    `${API_BASE_URL}/tools/${toolId}/desktop/${platform}/download?ticket=${encodeURIComponent(data.ticket)}`;
  return data;
};
